const formatCurrency = (value, currency) => {
  if (value > 0) {
    return value.toLocaleString('pt-br', { style: 'currency', currency });
  } else {
    return null;
  }
};

export default formatCurrency;
